import { FC } from 'react';

const ZoomOutIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path
      d="M15.4414 9.5332C15.4413 6.27018 12.7962 3.625 9.5332 3.625C6.27022 3.62507 3.62507 6.27022 3.625 9.5332C3.625 12.7962 6.27018 15.4413 9.5332 15.4414C12.7963 15.4414 15.4414 12.7963 15.4414 9.5332ZM11.9998 8.87484C12.345 8.87484 12.6247 9.15473 12.6248 9.49984C12.6248 9.84502 12.345 10.1248 11.9998 10.1248H6.99984C6.65473 10.1247 6.37484 9.84496 6.37484 9.49984C6.37493 9.15479 6.65479 8.87493 6.99984 8.87484H11.9998ZM16.6914 9.5332C16.6914 11.3052 16.0457 12.9251 14.9792 14.1751L17.4344 16.5506C17.6825 16.7906 17.6891 17.1863 17.4491 17.4344C17.2091 17.6825 16.8134 17.6891 16.5653 17.4491L14.0897 15.054C12.8518 16.0768 11.2643 16.6914 9.5332 16.6914C5.57982 16.6913 2.375 13.4866 2.375 9.5332C2.37507 5.57987 5.57987 2.37507 9.5332 2.375C13.4866 2.375 16.6913 5.57982 16.6914 9.5332Z"
      fill="#010203"
    />
  </svg>
);

export default ZoomOutIcon;
